import { render, staticRenderFns } from "./statistiche.html?vue&type=template&id=03ce2ba8&scoped=true&"
import script from "./Statistiche.vue?vue&type=script&lang=js&"
export * from "./Statistiche.vue?vue&type=script&lang=js&"
import style0 from "./Statistiche.vue?vue&type=style&index=0&id=03ce2ba8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ce2ba8",
  null
  
)

export default component.exports